export default __webpack_public_path__ + "static/media/image.surreytech-limited.113bcdcd.png";